import { useEffect } from 'react';
import { htmlToDOM, domToReact } from 'html-react-parser';
import pages from '../content/pages.json';
import { siteOptions } from '../lib/siteRenderer';
import { useMenuDismiss } from '../hooks/useDomEffects';
import { useLocation } from 'react-router-dom';

const source = htmlToDOM(pages['/our-team'].html);
const findNode = (nodes, match) => {
  for (const node of nodes) {
    if (match(node)) return node;
    const child = node.children && findNode(node.children, match);
    if (child) return child;
  }
  return null;
};
const nav = findNode(source, n => n.name === 'nav' && n.attribs?.['aria-label'] === 'Primary');
const header = nav.parent.parent;
const footer = findNode(source, n => n.name === 'footer');

export const SiteChrome = ({ children }) => {
  const {pathname} = useLocation();
  useEffect(() => {
    document.body.className = pages['/our-team'].bodyClass;
  }, []);
  useMenuDismiss();
  return <>
    <a className="intake-skip" href="#main" data-testid="intake-skip-to-content">Skip to main content</a>
    {domToReact([header], siteOptions(pathname, true))}
    {children}
    {domToReact([footer], siteOptions(pathname, true))}
  </>;
};